<template>
    <div class="float-dialog" ref="myDialog" @click="setZIndex">
        <div class="title color-dark border-bottom">
            <slot name="title"></slot>
            <i @click="close" style="padding:10px;float:right;cursor: pointer;" class="el-icon-close"></i>
            <i @click="minus" style="padding:10px;float:right;cursor: pointer;" class="el-icon-minus"></i>
        </div>
        <div class="float-content">
            <slot></slot>
        </div>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { mapMutations } from 'vuex'

  export default {
      props:['width','height','data'],
      data(){
        return {

        }
      },
    computed: {
      // 使用对象展开运算符将 getter 混入 computed 对象中
      ...mapGetters([
        'floatzIndex',
      ])
    },
      mounted(){
        this.setZIndex()
        this.$refs.myDialog.style.width = this.width + 'px'
        this.$refs.myDialog.style.height = this.height + 'px'
        this.$refs.myDialog.style.left = (document.body.clientWidth-this.width)/2 + 'px'
      },
      methods:{
        setZIndex(){
          this.addzIndex()
          if(this.$refs.myDialog) {
            if(this.data.name === 'videoMonitor'){
              this.$refs.myDialog.style.zIndex = this.floatzIndex - 9000
            }else {
              this.$refs.myDialog.style.zIndex = this.floatzIndex
            }
          }
        },
        close(){
          this.$emit('close')
        },
        minus(){
          this.$emit('minus')
        },
        ...mapMutations([
          'addzIndex'
        ]),
      }
    }
</script>

<style lang="scss" scoped>
    .float-dialog{
        position: absolute;
        overflow: hidden;
        width:1000px;
        height:600px;
        top:50px;
        // left:30%;
        z-index:4000;
        .title{
            height:40px;
            padding-left:10px;
            line-height: 40px;
        }
        .float-content{
            padding:10px;
            margin-right:3px;
            margin-left:3px;
            height:calc(100% - 40px);
            overflow: auto;
        }
    }
</style>